import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('spa-candle', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54086 26.4339C6.2633 25.1848 7.21374 24 8.49323 24H39.5068C40.7863 24 41.7367 25.1848 41.4591 26.4339L38.348 40.4339C38.1447 41.3489 37.3331 42 36.3957 42H11.6043C10.6669 42 9.85532 41.3489 9.65197 40.4339L6.54086 26.4339Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.643 9.88858C22.0743 8.00815 23.1776 5.41033 23.774 4C24.8177 5.41033 27.084 8.94836 27.7997 10.8288C28.6942 13.1793 26.4578 16 23.774 16C21.0903 16 18.8538 12.2391 20.643 9.88858Z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16V24",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});